import React from 'react';
import { Task } from '@/context/TaskContext';
import { ClockIcon } from './icons/TimeIcons';
import { CheckCircleIcon } from './icons/NavigationIcons';
import { formatTime } from '@/lib/timeUtils';
import { useTaskDetailModal } from './tasks/TaskDetailModalContext';

interface CurrentTaskCardProps {
  task: import('@/context/TaskContext').Task;
}

const CurrentTaskCard: React.FC<CurrentTaskCardProps> = ({ task }) => {
  const { open } = useTaskDetailModal();

  // Ensure we have a valid task to prevent errors
  if (!task) return null;
  
  return (
    <div onClick={() => open(task)} className="cursor-pointer">
      {/* Task Title Section */}
      <div className="flex justify-between items-center">
        <h2 className="text-white text-xl line-clamp-1">{task.title}</h2>
        {/* 3-dot menu removed as requested */}
      </div>
      
      {/* Task Description Section */}
      <div>
        <p className="text-white text-sm line-clamp-2">{task.detail || task.description || ""}</p>
      </div>
      
      {/* Pomodoros and Time Section - more vertical space via py-3 */}
      <div className="flex items-center space-x-4 py-3">
        <div className="flex items-center">
          <CheckCircleIcon size={14} className="text-white/80 mr-1" />
          <span className="text-white text-sm">{task.pomodorosCompleted} pomodoros</span>
        </div>
        <div className="flex items-center text-white text-sm">
          <ClockIcon size={14} className="mr-1" />
          {formatTime(task.totalTimeSpent)}
        </div>
      </div>
    </div>
  );
};

export default CurrentTaskCard;
